import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';

const EVENT_PRODUCTS_SET_PRESET = 'EVENT_PRODUCTS_SET_PRESET';
const EVENT_PRODUCTS_SET_PRODUCT_PRESET = 'EVENT_PRODUCTS_SET_PRODUCT_PRESET';
const EVENT_PRODUCTS_SET_ERROR = 'EVENT_PRODUCTS_SET_ERROR';
const EVENT_PRODUCTS_SET_LOADER = 'EVENT_PRODUCTS_SET_LOADER';


const isObjEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

const initialState = {
  preset: {},
  product: {},
  isLoading: false,
  isError: false,
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case EVENT_PRODUCTS_SET_PRESET:
      return {
        ...state,
        preset: {
          ...state.preset,
          [payload.preset]: payload.items
        }
      };
    case EVENT_PRODUCTS_SET_PRODUCT_PRESET:
      return {
        ...state,
        product: {
          ...state.product,
          [payload.productId]: {
            ...(state.product[payload.productId] || {}),
          'items': payload.items
          }
        }
      };
    case EVENT_PRODUCTS_SET_LOADER:
      return {
        ...state,
        isLoading: payload.isLoading,
      };
    case EVENT_PRODUCTS_SET_ERROR:
      return {
        ...state,
        isError: payload.isError
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function fetchEventProductsByPreset(preset) {
  return dispatch => {

    dispatch({type: EVENT_PRODUCTS_SET_PRESET, payload: {preset, items: null}});

    return dispatch(api.getAll(`events/`, {criteria: {preset}}, {cache: 'default'}))
      .then(
        eventProductsResponse => dispatch({
          type: EVENT_PRODUCTS_SET_PRESET,
          payload: {preset, items: eventProductsResponse.content.items}
        }),
        eventProductsError => {
          dispatch({type: EVENT_PRODUCTS_SET_PRESET, payload: {preset, items: false}});

          throw eventProductsError;
        }
      );
  };
}

export function fetchEventProductsByProduct(productId, presetId) {

  presetId = presetId || {}

  return dispatch => {
    dispatch({type: EVENT_PRODUCTS_SET_PRODUCT_PRESET, payload: {productId, presetId, items: null}});
    dispatch({
      type: EVENT_PRODUCTS_SET_LOADER,
      payload: { isLoading: true }
    });
    return dispatch(
      api.getAll('events/', { criteria: isObjEmpty(presetId) ? { presetId, productId } : { productId } }, { cache: 'default' })
    )
      .then((eventProductsResponse) => {
        dispatch({
          type: EVENT_PRODUCTS_SET_PRODUCT_PRESET,
          payload: { presetId, productId, items: eventProductsResponse.content.items }
        });
      })
      .catch((eventProductsError) => {
        dispatch({
          type: EVENT_PRODUCTS_SET_ERROR,
          payload: { isError: true }
        });
        throw eventProductsError;
      })
      .finally(() => {
        dispatch({
          type: EVENT_PRODUCTS_SET_LOADER,
          payload: { isLoading: false }
        });
      });
  };
}



// WEBPACK FOOTER //
// ./ducks/eventProducts.js